import { render, staticRenderFns } from "./ContractsPanel.vue?vue&type=template&id=9d47c688&"
import script from "./ContractsPanel.vue?vue&type=script&lang=js&"
export * from "./ContractsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContractsPanel.vue"
export default component.exports